import { render, staticRenderFns } from "./PolitiqueDeConfidentialite.vue?vue&type=template&id=37eda6c6"
import script from "./PolitiqueDeConfidentialite.vue?vue&type=script&lang=ts"
export * from "./PolitiqueDeConfidentialite.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports